import type { IContactBase } from '@/interfaces/IContactBase';
import { ContactFormSchema, type PhoneConflictInfo } from '@/schemas';
import { NForm, NFormItemGi, NGrid, NInput, NInputGroup, NSelect } from 'naive-ui';
import { defineComponent, type PropType } from 'vue';
import { AppInputPhone } from '../Inputs';
import { defineForm } from './FormBase';

export const ContactForm = defineComponent({
	name: 'ContactForm',
	extends: defineForm<IContactBase>(),
	props: {
		renterId: {
			type: String,
			default: '',
		},
		originalEmail: {
			type: String,
			default: undefined,
		},
		originalPhone: {
			type: String,
			default: undefined,
		},
		forbiddenEmails: {
			type: Array as () => string[],
			default: () => [],
		},
		forbiddenPhones: {
			type: Array as () => string[],
			default: () => [],
		},
		onPhoneConflict: {
			type: Function as PropType<(info: PhoneConflictInfo) => void>,
			default: undefined,
		},
	},

	computed: {
		phoneType: {
			get(): 'Cel' | 'Tel' {
				return (this.formData.phoneType || 'Cel') as 'Cel' | 'Tel';
			},
			set(val: 'Cel' | 'Tel') {
				this.formData.phoneType = val;
			},
		},
		formRules() {
			return ContactFormSchema(
				this.renterId,
				this.phoneType,
				this.originalEmail,
				this.originalPhone,
				this.forbiddenEmails,
				this.forbiddenPhones,
				this.onPhoneConflict,
			);
		},
	},

	created() {
		if (!this.formData.phoneType) {
			this.formData.phoneType = 'Cel';
		}
	},

	render() {
		return (
			<NForm
				size="large"
				ref="formRef"
				model={this.formData}
				rules={this.formRules}
				label-placement="top"
			>
				<NGrid cols="1 400:2" x-gap="4" y-gap="4">
					<NFormItemGi label="Email" path="email">
						<NInput
							placeholder="exemplo@email.com"
							inputProps={{ type: 'email' }}
							v-model:value={this.formData.email}
						/>
					</NFormItemGi>
					<NFormItemGi label="Telefone" path="phone">
						<NInputGroup>
							<NSelect
								style="width: 30%"
								v-model:value={this.phoneType}
								options={[
									{ label: 'Celular', value: 'Cel' },
									{ label: 'Telefone', value: 'Tel' },
								]}
							/>
							<AppInputPhone phoneType={this.phoneType} v-model={this.formData.phone}/>
						</NInputGroup>
					</NFormItemGi>
				</NGrid>
			</NForm>
		);
	},
});

export default ContactForm;
